import * as React from "react";
import { useMemo } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const options = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      networkMode: "always"
    }
  }
};
const LoginQueryClientProvider = ({ children }) => {
  const queryClient = useMemo(() => new QueryClient(options), []);
  return /* @__PURE__ */ React.createElement(QueryClientProvider, { client: queryClient }, children);
};
export default LoginQueryClientProvider;
